import React from 'react';
import classnames from 'classnames';

import { connect } from 'react-redux';

import styles from './index.scss';

import moment from 'moment';

import RangedDtPicker from '../../../components/RangedDtPicker';
import { AlertsAndHitsChart } from './RiskViewCharts/AlertsAndHits';
import { HitsDistributionChart } from './RiskViewCharts/HitsDistribution';
import { BusinessSegmentsAndParameters } from './RiskViewCharts/BusinessSegmentsAndParameters';
import { CustomerViewChart } from './RiskViewCharts/CustomerView';
import { FiguresSection } from './FiguresSection';

import { getItemFromLocalStorage } from '../../../util/localStorageUtils';
import { isUiResourceAvailable } from '../../../util/index';

import {
  getFigureData,
  getAlertsAndHitsChart,
  getHitsDistributionChart,
  getSegments,
  getBusinessSegmentsParametersData,
  getCustomerViewData
} from '../../../redux/actions/ns/dashboard';
import { getSelectedResources } from '../../../util/resourceManager';

import { forOwn } from '../../../util/lodashlike';
const INDIVIDUAL_TYPE = 0;
const CORPORATE_TYPE = 1;

const HEATMAP_VIEW = 0;
const GRAPHICAL_VIEW = 1;

const defaultSegment = {
  code: '-',
  id: '-',
  name: 'All Segments'
};

const { nsUserManagementResources } = getSelectedResources();

export class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    let chartBizParamsFilterPref = '{}';

    try {
      chartBizParamsFilterPref =
        localStorage.getItem('nsDashboardChartBizParamsFilter') ||
        '{"Parameters":{"totalAlerts":true,"totalHits":true,"trueHits":true,"falseHits":true,"undetermined":true,"level1":true}}';
    } catch (err) {}

    this.state = {
      selectedDateRange: {
        startDate: moment().subtract(30, 'days').add(1, 'days'),
        endDate: moment(),
        activeRangeNo: 2
      },
      isAlertsAndHitsChartCollapsed: false,
      isHitsDistributionChartCollapsed: false,
      isCustomerViewCollapsed: false,
      selectedType: INDIVIDUAL_TYPE,
      selectedBusinessSegmentGraphType: GRAPHICAL_VIEW,
      selectedSegmentBusinessParameters: defaultSegment,
      selectedSegmentCustomerView: defaultSegment,
      businessParamsFilter: JSON.parse(chartBizParamsFilterPref)
    };
  }

  componentDidMount() {
    const { selectedDateRange, selectedType } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };
    this.makeCommonApiCalls(requestParams);
  }

  onBusinessSegmentChartTypeChange = (type) => {
    this.setState({
      ...this.state,
      selectedBusinessSegmentGraphType: type
    });
  };

  onBusinessSegmentParametersSegmentChange = (segment) => {
    const { selectedDateRange, selectedType } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };

    if (segment.code !== '-') {
      requestParams['segmentCode'] = segment.code;
    }

    this.setState(
      {
        ...this.state,
        selectedSegmentBusinessParameters: segment
      },
      () => {
        if (this.props.fetchBusinessAndParametersData) {
          this.props.fetchBusinessAndParametersData(requestParams);
        }
      }
    );
  };

  onChartBusinessParametersFilterChange = (filterPref) => {
    let paramsFilter = this.state.businessParamsFilter;

    forOwn(filterPref, (value, key) => {
      paramsFilter[key] = value;
    });

    this.setState({
      ...this.state,
      businessParamsFilter: paramsFilter
    });

    localStorage.setItem(
      'nsDashboardChartBizParamsFilter',
      JSON.stringify(this.state.businessParamsFilter)
    );
  };

  onCustomerViewSegmentChange = (segment) => {
    const { selectedDateRange, selectedType } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };

    if (segment && segment.code !== '-') {
      requestParams['segmentCode'] = segment.code;
    }

    this.setState(
      {
        ...this.state,
        selectedSegmentCustomerView: segment
      },
      () => {
        if (this.props.fetchCustomerViewData) {
          this.props.fetchCustomerViewData(requestParams);
        }
      }
    );
  };

  onDateChange = (start, end, rangeNo) => {
    const { selectedType, selectedSegmentBusinessParameters } = this.state;
    const newDateRange = {
      startDate: start,
      endDate: end,
      activeRangeNo: rangeNo
    };

    this.setState(
      {
        ...this.state,
        selectedDateRange: newDateRange,
        selectedSegmentBusinessParameters: defaultSegment,
        selectedSegmentCustomerView: defaultSegment
      },
      () => {
        const requestParams = {
          to: moment(end).format('DD/MM/YYYY'),
          from: moment(start).format('DD/MM/YYYY'),
          alertType: selectedType
        };
        this.makeCommonApiCalls(requestParams);
      }
    );
  };

  onTypeChange = (type) => {
    const { selectedType, selectedDateRange } = this.state;
    if (type !== selectedType) {
      this.setState(
        {
          ...this.state,
          selectedType: type,
          selectedSegmentCustomerView: defaultSegment,
          selectedSegmentBusinessParameters: defaultSegment
        },
        () => {
          const requestParams = {
            to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
            from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
            alertType: type
          };
          this.makeCommonApiCalls(requestParams);
        }
      );
    }
  };

  makeCommonApiCalls = (requestParams) => {
    const {
      authentication,
      fetchFigureData,
      fetchSegments,
      fetchAlertsAndHitsChart,
      fetchHitsDistributionChart,
      fetchBusinessAndParametersData,
      fetchCustomerViewData
    } = this.props;

    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';

    fetchFigureData && fetchFigureData(requestParams);

    fetchSegments && fetchSegments(requestParams);

    if (isUsingUserManagement) {
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_ALERTS_HITS_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          fetchAlertsAndHitsChart && fetchAlertsAndHitsChart(requestParams);
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_HITS_DISTRIBUTTION_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          fetchHitsDistributionChart &&
            fetchHitsDistributionChart(requestParams);
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          fetchBusinessAndParametersData &&
            fetchBusinessAndParametersData(requestParams);
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_CUSTOMER_VIEW_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          fetchCustomerViewData && fetchCustomerViewData(requestParams);
        }
      }
    } else {
      fetchAlertsAndHitsChart && fetchAlertsAndHitsChart(requestParams);

      fetchHitsDistributionChart && fetchHitsDistributionChart(requestParams);

      fetchBusinessAndParametersData &&
        fetchBusinessAndParametersData(requestParams);

      fetchCustomerViewData && fetchCustomerViewData(requestParams);
    }
  };

  reloadAlertsAndHitsChartData = () => {
    const { selectedDateRange, selectedType } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };

    if (this.props.fetchAlertsAndHitsChart) {
      this.props.fetchAlertsAndHitsChart(requestParams);
    }
  };

  reloadBusinessSegmentsAndParametersData = () => {
    const {
      selectedDateRange,
      selectedType,
      selectedSegmentBusinessParameters
    } = this.state;
    let requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };

    if (selectedSegmentBusinessParameters.code !== '-') {
      requestParams['segmentCode'] = selectedSegmentBusinessParameters.code;
    }

    if (this.props.fetchBusinessAndParametersData) {
      this.props.fetchBusinessAndParametersData(requestParams);
    }
  };

  reloadCustomerViewData = () => {
    const { selectedDateRange, selectedType, selectedSegmentCustomerView } =
      this.state;
    let requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };

    if (selectedSegmentCustomerView.code !== '-') {
      requestParams['segmentCode'] = selectedSegmentCustomerView.code;
    }

    if (this.props.fetchCustomerViewData) {
      this.props.fetchCustomerViewData(requestParams);
    }
  };

  reloadFigureData = () => {
    const { selectedDateRange, selectedType } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };

    if (this.props.fetchFigureData) {
      this.props.fetchFigureData(requestParams);
    }
  };

  reloadHitsDistributionChartsData = () => {
    const { selectedDateRange, selectedType } = this.state;
    const requestParams = {
      to: moment(selectedDateRange.endDate).format('DD/MM/YYYY'),
      from: moment(selectedDateRange.startDate).format('DD/MM/YYYY'),
      alertType: selectedType
    };

    if (this.props.fetchHitsDistributionChart) {
      this.props.fetchHitsDistributionChart(requestParams);
    }
  };

  toggleAlertsAndHitsChartPanel = () => {
    const { isAlertsAndHitsChartCollapsed } = this.state;
    this.setState({
      ...this.state,
      isAlertsAndHitsChartCollapsed: !isAlertsAndHitsChartCollapsed
    });
  };

  toggleCustomerViewPanel = () => {
    const { isCustomerViewCollapsed } = this.state;
    this.setState({
      ...this.state,
      isCustomerViewCollapsed: !isCustomerViewCollapsed
    });
  };

  toggleHitsDistributionChartPanel = () => {
    const { isHitsDistributionChartCollapsed } = this.state;
    this.setState({
      ...this.state,
      isHitsDistributionChartCollapsed: !isHitsDistributionChartCollapsed
    });
  };

  renderAlertsAndHitsChart = () => {
    const { isAlertsAndHitsChartCollapsed } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.alertsAndHits) {
      const alertsAndHitsData = dashboard.alertsAndHits?.data
        ? dashboard.alertsAndHits.data
        : null;
      const alertsAndHitsIsLoading = dashboard.alertsAndHits?.data
        ? dashboard.alertsAndHits.isLoading
        : null;
      return (
        <AlertsAndHitsChart
          onTogglePanelVisibility={this.toggleAlertsAndHitsChartPanel}
          isCollapsed={isAlertsAndHitsChartCollapsed}
          isLoading={alertsAndHitsIsLoading}
          data={alertsAndHitsData}
          onReload={this.reloadAlertsAndHitsChartData}
        />
      );
    }

    return null;
  };

  renderBusinessSegmentsAndParametersPanel = () => {
    const {
      selectedBusinessSegmentGraphType,
      selectedSegmentBusinessParameters,
      businessParamsFilter
    } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.hitsDistribution) {
      const businessSegmentsParametersData = dashboard
        .businessSegmentsParameters?.data
        ? dashboard.businessSegmentsParameters.data
        : null;
      const businessSegmentsParametersIsLoading = dashboard
        .businessSegmentsParameters?.data
        ? dashboard.businessSegmentsParameters.isLoading
        : false;
      const segmentList = dashboard.segments?.data
        ? dashboard.segments.data
        : [];
      return (
        <BusinessSegmentsAndParameters
          segmentList={segmentList}
          selectedSegment={selectedSegmentBusinessParameters}
          onSegmentChange={this.onBusinessSegmentParametersSegmentChange}
          onGraphViewChange={this.onBusinessSegmentChartTypeChange}
          activeGraphView={selectedBusinessSegmentGraphType}
          isLoading={businessSegmentsParametersIsLoading}
          data={businessSegmentsParametersData}
          onReload={this.reloadBusinessSegmentsAndParametersData}
          businessParamsFilter={businessParamsFilter}
          onChartBusinessParametersFilterChange={
            this.onChartBusinessParametersFilterChange
          }
        />
      );
    }

    return null;
  };

  renderCustomerViewChart = () => {
    const { isCustomerViewCollapsed, selectedSegmentCustomerView } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.hitsDistribution) {
      const customerViewData = dashboard.customerView?.data
        ? dashboard.customerView.data
        : null;
      const customerViewIsLoading = dashboard.customerView?.data
        ? dashboard.customerView.isLoading
        : false;
      const segmentList = dashboard.segments?.data
        ? dashboard.segments.data
        : [];
      return (
        <CustomerViewChart
          data={customerViewData}
          segmentList={segmentList}
          selectedSegment={selectedSegmentCustomerView}
          isLoading={customerViewIsLoading}
          isCollapsed={isCustomerViewCollapsed}
          onTogglePanelVisibility={this.toggleCustomerViewPanel}
          onReload={this.reloadCustomerViewData}
          onSegmentChange={this.onCustomerViewSegmentChange}
        />
      );
    }

    return null;
  };

  renderDashboardHeaderControls = () => {
    const { selectedType, selectedDateRange } = this.state;
    return (
      <div className={classnames('row', styles.dashboardHeaderControls)}>
        <div className="col-md-7">
          <div className={styles.dateRangeContainer}>
            <RangedDtPicker
              startDate={selectedDateRange.startDate}
              endDate={selectedDateRange.endDate}
              activeRangeNo={selectedDateRange.activeRangeNo}
              onDateChange={this.onDateChange}
            />
          </div>
        </div>
        <div className={classnames('offset-md-3 col-md-2')}>
          <div
            className={classnames('btn-group', styles.typeButtonGroup)}
            role="group"
            aria-label="Type Toggle">
            <button
              onClick={() => this.onTypeChange(INDIVIDUAL_TYPE)}
              type="button"
              className={classnames(
                'btn',
                selectedType === INDIVIDUAL_TYPE ? styles.selected : ''
              )}>
              Individual
            </button>
            <button
              onClick={() => this.onTypeChange(CORPORATE_TYPE)}
              type="button"
              className={classnames(
                'btn',
                selectedType === CORPORATE_TYPE ? styles.selected : ''
              )}>
              Corporate
            </button>
          </div>
        </div>
      </div>
    );
  };

  renderFigures = () => {
    const { dashboard } = this.props;
    if (dashboard?.figures) {
      const figureData = dashboard.figures?.data
        ? dashboard.figures.data
        : null;
      const figureDataIsLoading = dashboard.figures?.isLoading
        ? dashboard.figures.isLoading
        : null;

      return (
        <FiguresSection
          data={figureData}
          isLoading={figureDataIsLoading}
          onReload={this.reloadFigureData}
        />
      );
    }
  };

  renderHitsDistributionChart = () => {
    const { isHitsDistributionChartCollapsed } = this.state;
    const { dashboard } = this.props;
    if (dashboard?.hitsDistribution) {
      const hitsDistributionData = dashboard.hitsDistribution?.data
        ? dashboard.hitsDistribution.data
        : null;
      const hitsDistributionIsLoading = dashboard.hitsDistribution?.data
        ? dashboard.hitsDistribution.isLoading
        : false;
      return (
        <HitsDistributionChart
          onTogglePanelVisibility={this.toggleHitsDistributionChartPanel}
          isCollapsed={isHitsDistributionChartCollapsed}
          isLoading={hitsDistributionIsLoading}
          data={hitsDistributionData}
          onReload={this.reloadHitsDistributionChartsData}
        />
      );
    }

    return null;
  };

  render() {
    const { authentication } = this.props;
    const isUsingUserManagement =
      getItemFromLocalStorage('user-management-enabled') === 'true';
    // make it default to true if user management is not used
    const defaultUserManagementFlag = isUsingUserManagement ? false : true;
    let isAlertsAndHitsAllowed = defaultUserManagementFlag;
    let isHitsDistributionAllowed = defaultUserManagementFlag;
    let isBusinessSegmentsAndParametersAllowed = defaultUserManagementFlag;
    let isCustomerViewAllowed = defaultUserManagementFlag;

    // start iterating widgets if authentication data is available
    // and if user management is allowed
    if (isUsingUserManagement) {
      // check if authentication data is there (UI resources)
      if (
        authentication &&
        Array.isArray(authentication.data) &&
        authentication.data.length > 0
      ) {
        const listOfUiResources = authentication.data?.map((attributeItem) => {
          return attributeItem?.details?.resource?.resourceCode;
        });

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_ALERTS_HITS_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          isAlertsAndHitsAllowed = true;
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_HITS_DISTRIBUTTION_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          isHitsDistributionAllowed = true;
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          isBusinessSegmentsAndParametersAllowed = true;
        }

        if (
          isUiResourceAvailable(
            nsUserManagementResources.NS_CUSTOMER_VIEW_CHART_WIDGET,
            listOfUiResources
          )
        ) {
          isCustomerViewAllowed = true;
        }
      }
    }

    return (
      <div className="row">
        <div className="col-md-12">
          {/* Header for DatePicker and Individual & Corporate toggle */}

          {this.renderDashboardHeaderControls()}

          {/* Figures Section */}

          {this.renderFigures()}

          {/* Alerts & Hits and Hits Distribution Chart goes here */}

          {(isAlertsAndHitsAllowed || isHitsDistributionAllowed) && (
            <div className={classnames('row', styles.chartsSection)}>
              {isAlertsAndHitsAllowed && (
                <div className="col-md-6">
                  {this.renderAlertsAndHitsChart()}
                </div>
              )}

              {isHitsDistributionAllowed && (
                <div className="col-md-6">
                  {this.renderHitsDistributionChart()}
                </div>
              )}
            </div>
          )}

          {/* Business Segments and Parameters */}

          {isBusinessSegmentsAndParametersAllowed && (
            <div className={classnames('row', styles.chartsSection)}>
              <div className="col-md-12">
                {this.renderBusinessSegmentsAndParametersPanel()}
              </div>
            </div>
          )}

          {/* Customer View */}

          {isCustomerViewAllowed && (
            <div className={classnames('row', styles.chartsSection)}>
              <div className="col-md-12">{this.renderCustomerViewChart()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps = {}) {
  return {
    dashboard: state.nsDashboard,
    authentication: state.authentication
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchFigureData: (payload) => {
      dispatch(getFigureData(payload));
    },
    fetchAlertsAndHitsChart: (payload) => {
      dispatch(getAlertsAndHitsChart(payload));
    },
    fetchHitsDistributionChart: (payload) => {
      dispatch(getHitsDistributionChart(payload));
    },
    fetchSegments: (payload) => {
      dispatch(getSegments(payload));
    },
    fetchBusinessAndParametersData: (payload) => {
      dispatch(getBusinessSegmentsParametersData(payload));
    },
    fetchCustomerViewData: (payload) => {
      dispatch(getCustomerViewData(payload));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
